import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Redirect, Route } from "react-router-dom";
import './App.css';

import "arc-design/styles/global.css";
import Layout from "arc-design/components/layout";

// components
import {
  CityProfile,
  //EmissionComparisons,
  //HazardComparisons
} from './screens';

import { QdtProvider } from './providers';

class App extends Component {

  render() {
    return (
      <QdtProvider>
        <Router basename="/anon/extensions/c40-KH-NetworksDiagram">
          <div className="App">
            <Layout>
              { <Layout.PrimaryHeader>
                <span className="app-title"> </span>
                {/* <div style={{ display: 'inline-block', width: '200px', marginLeft: '40px', verticalAlign: 'middle' }}>
                  <QdtComponent props={{
                    id: "dc208385-30c5-480f-9bf9-e8b3ca4e72b6",
                    height: "28px"
                  }} />
                </div> */}
              </Layout.PrimaryHeader> }
              <Switch>
                <Route path="/cities" component={CityProfile}></Route>
                <Redirect to="/cities"></Redirect>
              </Switch>
            </Layout>
          </div>
        </Router>
      </QdtProvider>
    );
  }

}

export default App;
